module.exports = __webpack_public_path__ + "img/video-cover__tony-2.80aab429.jpg";